import underConstruction from '../images/website-under-construction.jpg';

function App() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:wght@400;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          background: #1a1a1a;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          font-family: 'Montserrat', sans-serif;
        }
          #root {
            width: 100%;
            padding: 0px;
            padding-top: 80px;
          }
        .card {
          position: relative;
          width: 100%;
          background: #1a1a1a;
          overflow: hidden;
        }
        .top-section {
          background: linear-gradient(180deg, #0d0d0d 0%, #1a1a1a 100%);
          padding: 48px 60px 36px;
          text-align: center;
          position: relative;
        }
        .top-section::after {
          content: '';
          position: absolute;
          bottom: 0; left: 10%; right: 10%;
          height: 1px;
          background: linear-gradient(90deg, transparent, #f0c84a55, transparent);
        }
        .brand {
          font-family: 'Bebas Neue', sans-serif;
          font-size: 15px;
          letter-spacing: 8px;
          color: #f0c84a;
          margin-bottom: 18px;
          opacity: 0.85;
        }
        .main-title {
          font-family: 'Bebas Neue', sans-serif;
          font-size: clamp(34px, 5vw, 58px);
          line-height: 1.05;
          color: #ffffff;
          letter-spacing: 2px;
          text-shadow: 0 2px 20px rgba(0,0,0,0.6);
        }
        .main-title span {
          color: #f0c84a;
        }
        .subtitle {
          margin-top: 14px;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 5px;
          color: #aaaaaa;
          text-transform: uppercase;
        }
        .image-wrapper {
          position: relative;
          line-height: 0;
        }
        .image-wrapper img {
          width: 100%;
          display: block;
        }
        .image-wrapper::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 60px;
          background: linear-gradient(180deg, #1a1a1a, transparent);
          z-index: 2;
        }
        .image-wrapper::after {
          content: '';
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 80px;
          background: linear-gradient(0deg, #1a1a1a, transparent);
          z-index: 2;
        }
        .bottom-section {
          background: #0d0d0d;
          padding: 24px 60px 24px;
          text-align: center;
          position: relative;
        }
        .bottom-section::before {
          content: '';
          position: absolute;
          top: 0; left: 10%; right: 10%;
          height: 1px;
          background: linear-gradient(90deg, transparent, #f0c84a44, transparent);
        }
        .follow-text {
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 3px;
          color: #888888;
          text-transform: uppercase;
        }
        .follow-text span {
          color: #f0c84a;
          font-weight: 600;
        }
        .dots {
          display: flex;
          justify-content: center;
          gap: 6px;
          margin-top: 14px;
        }
        .dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          background: #f0c84a;
          opacity: 0.4;
        }
        .dot.active { opacity: 1; }
      `}</style>

      <div className="card">
        <div className="top-section">
          <div className="brand">— Psycle —</div>
          <div className="main-title">
            Regresamos pronto con<br />
            <span>nueva ubicación</span> y nuevo<br />
            rediseño de nuestro sitio web<br />
            para brindarte un mejor servicio
          </div>
          <div className="subtitle">Estamos trabajando en algo increíble</div>
        </div>
        <div className="image-wrapper">
          <img src={underConstruction} alt="Psycle" />
        </div>
        <div className="bottom-section">
          <div className="follow-text">
            Síguenos en <span>@psycle.mx</span> para más novedades
          </div>
        </div>
      </div>
    </>
  );
}

export default App;